/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TrackCollaboratorNotificationAction } from './TrackCollaboratorNotificationAction';
import {
    TrackCollaboratorNotificationActionFromJSON,
    TrackCollaboratorNotificationActionFromJSONTyped,
    TrackCollaboratorNotificationActionToJSON,
} from './TrackCollaboratorNotificationAction';

/**
 *
 * @export
 * @interface TrackCollaboratorNotification
 */
export interface TrackCollaboratorNotification {
    /**
     *
     * @type {string}
     * @memberof TrackCollaboratorNotification
     */
    type: TrackCollaboratorNotificationTypeEnum;
    /**
     *
     * @type {string}
     * @memberof TrackCollaboratorNotification
     */
    groupId: string;
    /**
     *
     * @type {boolean}
     * @memberof TrackCollaboratorNotification
     */
    isSeen: boolean;
    /**
     *
     * @type {number}
     * @memberof TrackCollaboratorNotification
     */
    seenAt?: number;
    /**
     *
     * @type {Array<TrackCollaboratorNotificationAction>}
     * @memberof TrackCollaboratorNotification
     */
    actions: Array<TrackCollaboratorNotificationAction>;
}


/**
 * @export
 */
export const TrackCollaboratorNotificationTypeEnum = {
    Invite: 'track_collaborator_invite',
    Accept: 'track_collaborator_accept'
} as const;
export type TrackCollaboratorNotificationTypeEnum = typeof TrackCollaboratorNotificationTypeEnum[keyof typeof TrackCollaboratorNotificationTypeEnum];


/**
 * Check if a given object implements the TrackCollaboratorNotification interface.
 */
export function instanceOfTrackCollaboratorNotification(value: object): value is TrackCollaboratorNotification {
    let isInstance = true;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "groupId" in value && value["groupId"] !== undefined;
    isInstance = isInstance && "isSeen" in value && value["isSeen"] !== undefined;
    isInstance = isInstance && "actions" in value && value["actions"] !== undefined;

    return isInstance;
}

export function TrackCollaboratorNotificationFromJSON(json: any): TrackCollaboratorNotification {
    return TrackCollaboratorNotificationFromJSONTyped(json, false);
}

export function TrackCollaboratorNotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackCollaboratorNotification {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'type': json['type'],
        'groupId': json['group_id'],
        'isSeen': json['is_seen'],
        'seenAt': !exists(json, 'seen_at') ? undefined : json['seen_at'],
        'actions': ((json['actions'] as Array<any>).map(TrackCollaboratorNotificationActionFromJSON)),
    };
}

export function TrackCollaboratorNotificationToJSON(value?: TrackCollaboratorNotification | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'type': value.type,
        'group_id': value.groupId,
        'is_seen': value.isSeen,
        'seen_at': value.seenAt,
        'actions': ((value.actions as Array<any>).map(TrackCollaboratorNotificationActionToJSON)),
    };
}
